import { webSlice } from "../../../webSlice";

export const davdoxxxWebSlice = webSlice.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getPdfDav: builder.mutation({
      query: ({ DOCNROXX }) => ({
        url: `/Modimpxx/Nacional/Davdoxxx/getPdfDav/${DOCNROXX}`,
        method: "GET",
      }),
    }),
  }),
});

export const { useGetPdfDavMutation } = davdoxxxWebSlice;
